import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Collections = () => {
  const [selectedCollection, setSelectedCollection] = useState(null);
  const navigate = useNavigate();

  const collections = [
    {
      id: 1,
      title: "Best Sellers",
      img: "https://cdn3.pixelcut.app/1/H2_3722ea66c2.png",
    },
    { id: 2, title: "Trending Now", img: "" },
    {
      id: 3,
      title: "New Arrivals",
      img: "https://t3.ftcdn.net/jpg/02/67/65/76/360_F_267657605_qgGbYzq3A7QQsWNH33ALAAAyiEN7ekXL.jpg",
    },
    {
      id: 4,
      title: "On Sale",
      img: "https://freedesignfile.com/upload/2017/11/Christmas-sale-background-red-vectors.jpg",
    },
    {
      id: 5,
      title: "Leaving Soon",
      img: "https://media.gettyimages.com/id/1840597123/vector/last-chance-neon-sale-clearance-glowing-message.jpg?s=612x612&w=gi&k=20&c=0tz9XQagn9J_5tmQnvJxasy6kCYHr2LiktKSm6oBrC4=",
    },
    { id: 6, title: "Seasonal", img: "" },
  ];

  const handleClick = (c) => {
    setSelectedCollection((prev) => (prev === c.id ? null : c.id));
  };

  const handleViewCollection = (title) => {
    navigate(`/collection/${title}`);
  };

  return (
    <div className="collections-container">
      <h3 className="collections-title">Collections</h3>
      <div className="collections-grid">
        {collections.map((collection) => (
          <div
            key={collection.id}
            onClick={() => handleClick(collection)}
            className="collection-card"
          >
            <span></span>
            {selectedCollection === collection.id && (
              <div className="collection-modal">
                <span onClick={() => handleViewCollection(collection.title)}>
                  View Collections
                </span>
              </div>
            )}
            <span className="collection-label">{collection.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Collections;
